import React from "react";
import { motion } from "framer-motion";

export const Stat = ({ label, value, sub, testid }) => (
  <div className="card-lux p-6" data-testid={testid}>
    <p className="text-xs uppercase tracking-widest text-neutral-500">{label}</p>
    <p className="font-serif-lux text-4xl mt-2 text-white">{value}</p>
    {sub && <p className="text-xs text-neutral-500 mt-1">{sub}</p>}
  </div>
);

export const SectionTitle = ({ eyebrow, title }) => (
  <div className="mb-8">
    {eyebrow && <p className="text-xs uppercase tracking-[0.3em] gold mb-3">{eyebrow}</p>}
    <h2 className="font-serif-lux text-4xl sm:text-5xl font-light text-white">{title}</h2>
  </div>
);

export const Pill = ({ children, active, onClick, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`px-4 py-2 text-sm rounded-sm transition-colors border ${
      active ? "bg-gold text-black border-gold" : "btn-ghost-lux"
    }`}
  >
    {children}
  </button>
);

export const StatusBadge = ({ status }) => {
  const map = {
    confirmed: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
    completed: "text-sky-400 border-sky-500/30 bg-sky-500/10",
    pending: "text-amber-400 border-amber-500/30 bg-amber-500/10",
    approved: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
    declined: "text-red-400 border-red-500/30 bg-red-500/10",
  };
  return (
    <span className={`text-xs px-2.5 py-1 rounded-sm border capitalize ${map[status] || "text-neutral-400 border-white/10"}`}>
      {status}
    </span>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6, delay }}
    className={className}
  >
    {children}
  </motion.div>
);
